module.exports = __webpack_public_path__ + "static/media/logo.84bb50b5.png";